import { render, staticRenderFns } from "./LocalLogin.vue?vue&type=template&id=b3bccd28"
import script from "./LocalLogin.vue?vue&type=script&lang=ts"
export * from "./LocalLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports